module.exports = __webpack_public_path__ + "img/full-potential@2x.45dd4b18.png";